$(document).ready(function() {
    focusOnSearchInputWhenSidebarOpens();
});

function focusOnSearchInputWhenSidebarOpens() {
    $('button[data-sidebar-id="SearchSidebar"]').on('click', function() {
      // console.log("evento activado?");
        setTimeout(function() {
            if ($('#SearchSidebar').hasClass('is-opened')) {
                $('input.search-field__input').focus();
            }
        }, 500);
    });
}

//Zoom Img Product
document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll(
    '.product-media-carousel__slide[data-zoom-cursor-target]'
  );

  slides.forEach((slide) => {
    const wrap = slide.querySelector('[data-product-zoom-wrap]');
    const img = slide.querySelector('[data-product-zoom-image]');

    if (!wrap || !img) return;

    const zoomLevel = 2.2;

    function resetZoom() {
      img.style.transformOrigin = 'center center';
      img.style.transform = 'scale(1)';
    }

    slide.addEventListener('mousemove', function (e) {
      const rect = wrap.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = `scale(${zoomLevel})`;
    });

    slide.addEventListener('mouseleave', resetZoom);
  });
});

document.addEventListener('DOMContentLoaded', initProductImageZoom);
document.addEventListener('shopify:section:load', initProductImageZoom);
//End Zoom Img Product

//Scroll-Pag controlado
/*(function () {
  const STORAGE_KEY = 'collection_state_v3';

  const SELECTORS = {
    productLinks: 'a[href*="/products/"]',
    productItems: '.horizontal-product-card, .vertical-product-card, .product-card, .grid__item',
    loadMoreButton: '[data-load-more], .load-more, .button-show-more, .pagination-load-more',
    paginationButtons: '.pagination a, .pagination button, [data-pagination-page]',
    activePagination: '.pagination .is-active, .pagination [aria-current="page"], [data-pagination-current="true"]'
  };

  function isCollectionPage() {
    return window.location.pathname.includes('/collections/');
  }

  function isProductPage() {
    return window.location.pathname.includes('/products/');
  }

  function getVisibleProductsCount() {
    return document.querySelectorAll(SELECTORS.productItems).length;
  }

  function getCurrentPageLabel() {
    const active = document.querySelector(SELECTORS.activePagination);
    if (!active) return null;
    return (active.textContent || '').trim();
  }

  function getState() {
    return {
      path: window.location.pathname,
      scrollY: window.scrollY || window.pageYOffset || 0,
      visibleItems: getVisibleProductsCount(),
      currentPageLabel: getCurrentPageLabel(),
      ts: Date.now()
    };
  }

  function sameCollection(state) {
    return state && state.path === window.location.pathname;
  }

  function saveStateToSession(state) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  function getSavedState() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function replaceHistoryState() {
    if (!isCollectionPage()) return;
    const state = getState();
    saveStateToSession(state);
    history.replaceState(
      Object.assign({}, history.state || {}, { collectionState: state }),
      document.title,
      window.location.pathname + window.location.search + window.location.hash
    );
  }

  function pushHistoryState() {
    if (!isCollectionPage()) return;
    const state = getState();
    saveStateToSession(state);
    history.pushState(
      Object.assign({}, history.state || {}, { collectionState: state }),
      document.title,
      window.location.pathname + window.location.search + window.location.hash
    );
  }

  function restoreScroll(state) {
    if (!state || typeof state.scrollY !== 'number') return;
    setTimeout(function () {
      window.scrollTo(0, state.scrollY);
    }, 150);
  }

  function clickPaginationToMatch(targetPageLabel, done) {
    if (!targetPageLabel) {
      done();
      return;
    }

    const active = document.querySelector(SELECTORS.activePagination);
    const activeLabel = active ? (active.textContent || '').trim() : null;

    if (activeLabel === targetPageLabel) {
      done();
      return;
    }

    const buttons = document.querySelectorAll(SELECTORS.paginationButtons);
    let matchedButton = null;

    buttons.forEach((btn) => {
      const label = (btn.textContent || '').trim();
      if (label === targetPageLabel) {
        matchedButton = btn;
      }
    });

    if (!matchedButton) {
      done();
      return;
    }

    matchedButton.click();
    setTimeout(done, 800);
  }

  function clickLoadMoreIfNeeded(targetVisibleCount, done) {
    if (!targetVisibleCount) {
      done();
      return;
    }

    let attempts = 0;
    const maxAttempts = 20;

    function step() {
      const currentCount = getVisibleProductsCount();
      const btn = document.querySelector(SELECTORS.loadMoreButton);

      if (currentCount >= targetVisibleCount || !btn || attempts >= maxAttempts) {
        done();
        return;
      }

      attempts += 1;
      btn.click();
      setTimeout(step, 700);
    }

    step();
  }

  function restoreCollectionState(state) {
    if (!isCollectionPage() || !sameCollection(state)) return;

    clickPaginationToMatch(state.currentPageLabel, function () {
      clickLoadMoreIfNeeded(state.visibleItems, function () {
        restoreScroll(state);
      });
    });
  }

  function attachProductClickSaver() {
    document.addEventListener('click', function (e) {
      const link = e.target.closest(SELECTORS.productLinks);
      if (!link || !isCollectionPage()) return;

      const state = getState();
      saveStateToSession(state);
      history.replaceState(
        Object.assign({}, history.state || {}, { collectionState: state }),
        document.title,
        window.location.pathname + window.location.search + window.location.hash
      );
    });
  }

  function attachInteractionTracking() {
    document.addEventListener('click', function (e) {
      const paginationBtn = e.target.closest(SELECTORS.paginationButtons);
      const loadMoreBtn = e.target.closest(SELECTORS.loadMoreButton);

      if (paginationBtn && isCollectionPage()) {
        setTimeout(function () {
          pushHistoryState();
        }, 500);
      }

      if (loadMoreBtn && isCollectionPage()) {
        setTimeout(function () {
          pushHistoryState();
        }, 700);
      }
    });

    let scrollTimer;
    window.addEventListener('scroll', function () {
      if (!isCollectionPage()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        replaceHistoryState();
      }, 150);
    }, { passive: true });
  }

  window.goBackSmart = function () {
    if (document.referrer && document.referrer.includes(window.location.hostname)) {
      history.back();
      return;
    }

    const saved = getSavedState();
    if (saved && saved.path) {
      window.location.href = saved.path;
      return;
    }

    history.back();
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (isCollectionPage()) {
      replaceHistoryState();
    }

    attachProductClickSaver();
    attachInteractionTracking();

    const saved = (history.state && history.state.collectionState) || getSavedState();
    if (saved) {
      restoreCollectionState(saved);
    }
  });

  window.addEventListener('popstate', function (event) {
    const state = event.state && event.state.collectionState;
    if (!state) return;

    setTimeout(function () {
      restoreCollectionState(state);
    }, 0);
  });

  window.addEventListener('pageshow', function () {
    const saved = (history.state && history.state.collectionState) || getSavedState();
    if (saved) {
      restoreCollectionState(saved);
    }
  });
})();*/
//End Scroll-Pag controlado